import { myInvoisPhoneNumFormItemName } from '../../../components/Input/PhoneNumberInputV3';
import { ContactEntityType } from '../../../enums/ContactEntityType';

// const fieldNameMap = {
//     legal_name: t`Legal Name`,
//     reg_no: t`Registration No.`,
//     reg_no_type: t`Registration No. Type`,
//     entity_type: t`Contact Entity Type`,
//     phone_no: t`Contact No.`,
//     phone_no_code: t`Contact No. Country Code`,
//     tax_id_no: t`TIN`,
//     addresses: t`Default Billing Address`,
//     street: t`Default Billing Address Street Address`,
//     city: t`Default Billing Address City`,
//     state: t`Default Billing Address State`,
//     country_code: t`Default Billing Address Country`,
// };

// checks if the field is filled + valid
export function myInvoisFieldValidAndFilledValidator(fieldData, key, form) {
    const isFilled = fieldData && fieldData.length > 0;
    if (key && form) {
        let isValidated = false;
        if (key === 'phone_no')
            isValidated = !form.getFieldError(myInvoisPhoneNumFormItemName).length;
        else
            isValidated = !form.getFieldError(key).length;

        return isFilled && isValidated;
    }

    return isFilled;
}

// fieldsData = ["asd", "asd", "asd"]
// check if all fields are filled
export function myInvoisSectionValidator(sectionFieldsData = [], sectionFieldsKey = [], form = {}) {
    return sectionFieldsData.every(
        (data, idx) => myInvoisFieldValidAndFilledValidator(data, sectionFieldsKey[idx], form));
}

// for every address in addresses, check if one of them have is_default_billing set to true
export function myInvoisAddressesHasDefaultBilling(addresses) {
    return addresses.some(address => address.is_default_billing);
}

export function myInvoisAddressesValidator(addresses) {
    if (!myInvoisAddressesHasDefaultBilling(addresses))
        return false;

    // for every address in addresses, check if street, city, state, country are fille
    return addresses.every(
        address => myInvoisSectionValidator(
            [address.street, address.city, address.state, address.country_code],
        ));
}

export function getDefaultBillingAddress(addresses) {
    return addresses.find(address => address.is_default_billing);
}

export function malaysiaAddressStateValidator(address = {}, malaysiaStatesList = []) {
    if (address.country_code === 'MY')
        return !!malaysiaStatesList.find(state => state.name === address.state);
    return true;
}

export function getDefaultBillingAddressMissingAndInvalidFields(address, malaysiaStatesList) {
    const missingFields = [];
    const requiredFields = ["street", "city", "state", "country_code"];
    for (const field of requiredFields) {
        if (!myInvoisFieldValidAndFilledValidator(address[field]))
            missingFields.push(field);
        else if (field === 'state' && !malaysiaAddressStateValidator(address, malaysiaStatesList))
            missingFields.push(field);
    }
    return missingFields;
}

function findAndRemoveElementFromArray(array, element) {
    const index = array.indexOf(element);
    if (index !== -1)
        array.splice(index, 1);

    return array;
}

// removing stuff from missingFields
// if entity_type is MALAYSIAN_INDIVIDUAL or FOREIGN_INDIVIDUAL
// [reg_no + reg_no_type must be filled] or tax_id_no must be filled, one of them can be empty
// if entity_type is FOREIGN_CONTACT/EXEMPTED_PERSON
// reg_no, reg_no_type, tax_id_no can be empty
function handleEntityTypeValidations(missingFields, entityType) {
    let newMissingFields = [...missingFields];
    switch (entityType) {
        case ContactEntityType.MALAYSIAN_INDIVIDUAL.key:
        case ContactEntityType.FOREIGN_INDIVIDUAL.key: {
            const regNoMissing = missingFields.includes("reg_no");
            const regNoTypeMissing = missingFields.includes("reg_no_type");
            const taxIdNoMissing = missingFields.includes("tax_id_no");

            // reg_no and reg_no_type can be empty if tax_id_no is filled
            // not missing means its filled
            if (!taxIdNoMissing) {
                newMissingFields = findAndRemoveElementFromArray(newMissingFields, "reg_no");
                newMissingFields = findAndRemoveElementFromArray(newMissingFields, "reg_no_type");
            }

            // tax_id_no can be empty if reg_no and reg_no_type is filled
            if (!regNoMissing && !regNoTypeMissing)
                newMissingFields = findAndRemoveElementFromArray(newMissingFields, "tax_id_no");

            // Though, if reg_no is filled, reg_no_type is required
            if (!regNoMissing && regNoTypeMissing)
                newMissingFields.push("reg_no_type");
            // Similarly if reg_no_type is filled, reg_no is required
            else if (!regNoTypeMissing && regNoMissing)
                newMissingFields.push("reg_no");
        }
            break;
        case ContactEntityType.GENERAL_PUBLIC.key:
        case ContactEntityType.FOREIGN_COMPANY.key:
        case ContactEntityType.EXEMPTED_PERSON.key: {
            // tax_id_no is optional, so if declared missing, can just remove it
            newMissingFields = findAndRemoveElementFromArray(newMissingFields, "tax_id_no");

            // For reg_no and reg_no_type, both must be filled or both must be empty
            const regNoMissing = missingFields.includes("reg_no");
            const regNoTypeMissing = missingFields.includes("reg_no_type");

            newMissingFields = findAndRemoveElementFromArray(newMissingFields, "reg_no");
            newMissingFields = findAndRemoveElementFromArray(newMissingFields, "reg_no_type");

            // If reg_no is filled, reg_no_type is required
            if (!regNoMissing && regNoTypeMissing)
                newMissingFields.push("reg_no_type");
            // Similarly if reg_no_type is filled, reg_no is required
            else if (!regNoTypeMissing && regNoMissing)
                newMissingFields.push("reg_no");

            break;
        }
        case ContactEntityType.MALAYSIAN_COMPANY.key:
        default:
            break;
    }

    return newMissingFields;
}

export function getMissingMyInvoisFields(contactMyInvoisFormFields) {
    const missingFields = [];
    // legal_name
    // reg_no + reg_no_type AND/OR tax_id_no (based on entity_type)
    // entity_type
    // phone_no
    // addresses, check each address with myInvoisAddressesValidator

    // Process all fields
    for (const [fieldName, fieldValue] of Object.entries(contactMyInvoisFormFields)) {
        if (fieldName === "entity_type")
            continue;

        if (fieldName === "addresses") {
            const defaultBillingAddress = getDefaultBillingAddress(fieldValue);
            if (!defaultBillingAddress) {
                missingFields.push("address");
            }
            else {
                ['street', 'city', 'state', 'country_code'].forEach(field => {
                    if (!defaultBillingAddress[field])
                        missingFields.push(field);
                });
            }
        }
        else if (!fieldValue) {
            missingFields.push(fieldName);
        }
    }

    // Process fields based on entity type
    const missingFieldsAfterEntityTypeHandling = handleEntityTypeValidations(
        missingFields,
        contactMyInvoisFormFields.entity_type,
    );

    return missingFieldsAfterEntityTypeHandling;
}

export function getFailedValidationMyInvoisFields(
    contactMyInvoisFormFields, malaysiaStatesList, missingMyInvoisFields, form,
) {
    const failedValidationFields = [];

    for (const [fieldName, fieldValue] of Object.entries(contactMyInvoisFormFields)) {
        if (fieldName === "entity_type")
            continue;
        if (fieldName === "addresses") {
            const defaultBillingAddress = getDefaultBillingAddress(fieldValue);

            if (!malaysiaAddressStateValidator(defaultBillingAddress, malaysiaStatesList) && !missingMyInvoisFields.includes('state'))
                failedValidationFields.push("state");
        }
        else if (fieldName === "phone_no" && form?.getFieldError(myInvoisPhoneNumFormItemName).length && !missingMyInvoisFields.includes(fieldName)) {
            failedValidationFields.push(fieldName);
        }
        // only add into failed validation fields if its not already in missing fields
        else if (form?.getFieldError(fieldName).length && !missingMyInvoisFields.includes(fieldName)) {
            failedValidationFields.push(fieldName);
        }
    }

    return failedValidationFields;
}
